import type { DeviceSearchSortBy, SortOrder } from '@/api/deviceApi'

export const DEFAULT_DEVICE_SORT: { sortBy: DeviceSearchSortBy; sortOrder: SortOrder } = {
	sortBy: 'uid',
	sortOrder: 'asc',
}

/** `?sort=` form of a device sort: `uid`, `id`, `metadata:<key>` or `state:<key>`. */
export function encodeDeviceSortParam(sortBy: DeviceSearchSortBy): string {
	if (sortBy === 'uid' || sortBy === 'id') {
		return sortBy
	}
	return 'metadata' in sortBy ? `metadata:${sortBy.metadata}` : `state:${sortBy.state}`
}

/** Inverse of `encodeDeviceSortParam`; null for a missing or unrecognised value. */
export function decodeDeviceSortParam(value: string | undefined): DeviceSearchSortBy | null {
	if (value === 'uid' || value === 'id') {
		return value
	}
	const separator = value?.indexOf(':') ?? -1
	if (!value || separator < 0) {
		return null
	}
	const kind = value.slice(0, separator)
	const key = value.slice(separator + 1)
	if (!key) {
		return null
	}
	if (kind === 'metadata') {
		return { metadata: key }
	}
	if (kind === 'state') {
		return { state: key }
	}
	return null
}

/** The sort a device list URL asks for. `order` only counts alongside `sort`, since the schema always fills it in. */
export function deviceSortFromSearch(search: { sort?: string; order?: SortOrder }): {
	sortBy: DeviceSearchSortBy
	sortOrder: SortOrder
} {
	const sortBy = decodeDeviceSortParam(search.sort)
	return sortBy ? { sortBy, sortOrder: search.order ?? 'asc' } : DEFAULT_DEVICE_SORT
}
